var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPnk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 807.9 714.1",
    style: {
      enableBackground: "new 0 0 807.9 714.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;fill:#45464D;enable-background:new    ;}\n\t.st1{fill:#656569;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:#757578;}\n\t.st6{fill:#6C6D70;}\n\t.st7{fill:#55565A;}\n\t.st8{opacity:0.7;fill:#151A22;enable-background:new    ;}\n\t.st9{opacity:0.7;fill:#23262E;enable-background:new    ;}\n\t.st10{opacity:0.7;fill:#43444B;enable-background:new    ;}\n\t.st11{opacity:0.7;fill:#34363D;enable-background:new    ;}\n\t.st12{opacity:0.7;fill:#36383F;enable-background:new    ;}\n\t.st13{opacity:0.7;fill:#3B3C43;enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "641.4,18.1 236,0 0,294.8 165.4,688.9 574.8,713.7 807.9,382.2  "
  })), /*#__PURE__*/React.createElement("g", null, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "807.9,382.6 577,148.4 516.2,597.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.357,
    y1: 351.118,
    x2: 576.977,
    y2: 351.118,
    gradientTransform: "matrix(1 0 0 -1 0 724.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A3A2A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2705,
    style: {
      stopColor: "#9F9EA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5607,
    style: {
      stopColor: "#929194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8592,
    style: {
      stopColor: "#7C7C80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707073"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "157.4,329.9 577,148.4 516.2,597.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.5822,
    y1: 400.2483,
    x2: 452.7339,
    y2: 695.5228,
    gradientTransform: "matrix(1 0 0 -1 0 724.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#969598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3396,
    style: {
      stopColor: "#908F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    style: {
      stopColor: "#7F7F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#757578"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "577,148.4 236,0.4 157.4,329.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.5621,
    y1: 404.4149,
    x2: 336.8316,
    y2: 88.5752,
    gradientTransform: "matrix(1 0 0 -1 0 724.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E9EA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2759,
    style: {
      stopColor: "#9B9B9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#919194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6923,
    style: {
      stopColor: "#808083"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8777,
    style: {
      stopColor: "#69696D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55565A"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "157.4,329.9 165.4,689.3 516.2,597.7  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "577,148.4 641.4,18.5 236,0.4  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "641.4,18.5 807.9,382.6 577,148.4  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "807.9,382.6 574.8,714.1 516.2,597.7  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "574.8,714.1 165.4,689.3 516.2,597.7  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "236,0.4 0,295.3 157.4,329.9  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,295.3 165.4,689.3 157.4,329.9  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "534,210.3 491.5,532.4 240.8,338.5  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "500.1,146.1 265.8,45.1 216.5,257.4  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "440.7,581.1 186,399.2 192.2,645.7  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "765.1,381.8 591.6,205.6 545.8,544.4  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "500.4,620.8 538.2,693.1 285.6,676.9  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "731.2,461.7 543.2,601.9 580.6,674.9  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "642.3,69.4 741.7,282.6 605.8,144.4  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "596.8,33.5 555,110 358.1,23.8  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "202.6,68.2 147.2,303.1 35.4,279.4  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "140.4,344.5 145.3,596.9 28.1,320.7  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnk);
export default __webpack_public_path__ + "static/media/pnk.3d03b105866e4926a289cc6801bc39bb.svg";
export { ForwardRef as ReactComponent };